export default __webpack_public_path__ + "static/media/empty-shop.18976711.png";